import {
  GET_CONSENT_STATUS,
  UPDATE_CONSENT,
  UPDATE_CONSENT_FAILED,
  GET_CONSENT_STATUS_FAILED,
  RECEIVE_DOCUMENT_CONTENT,
  GET_DOCUMENT_CONTENT,
  GET_DOCUMENT_CONTENT_FAILED,
  RESET_DOCUMENT_CONTENT,
} from './actions';

const initialState = {
  editingState: {
    context: null,
  },
  consentData: {
    data: null,
    error: null,
  },
  consentDocumentContent: {
    data: null,
    status: null,
  },
  latestConsentDocumentContent: {
    data: null,
    status: null,
  },
  refusalDocumentContent: {
    data: null,
    status: null,
  },
};

const getContext = (context) => {
  switch (context) {
    case 'currentConsent':
      return 'consentDocumentContent';
    case 'latestConsent':
      return 'latestConsentDocumentContent';
    case 'refusal':
      return 'refusalDocumentContent';
    default:
      throw 'Unknown context';
  }
};

const biobankReducer = (state = initialState, action) => {
  let { type, payload, context } = action;
  switch (type) {
    case GET_CONSENT_STATUS: {
      return {
        ...state,
        consentData: {
          ...state.consentData,
          data: payload.data,
        },
      };
    }
    case GET_CONSENT_STATUS_FAILED: {
      return {
        ...state,
        consentData: {
          ...state.consentData,
          error: payload.error,
        },
      };
    }
    case UPDATE_CONSENT: {
      return {
        ...state,
        consentData: {
          ...state.consentData,
          data: payload.data,
        },
      };
    }
    case UPDATE_CONSENT_FAILED: {
      return {
        ...state,
        error: payload.error,
      };
    }
    case RESET_DOCUMENT_CONTENT: {
      return {
        ...state,
        [getContext(context)]: {
          data: null,
          status: null,
        },
      };
    }
    case GET_DOCUMENT_CONTENT: {
      return {
        ...state,
        [getContext(context)]: {
          data: null,
          status: 'LOADING',
        },
      };
    }
    case RECEIVE_DOCUMENT_CONTENT: {
      return {
        ...state,
        [getContext(context)]: {
          data: payload.data,
          status: 'RECEIVED',
        },
      };
    }
    case GET_DOCUMENT_CONTENT_FAILED: {
      return {
        ...state,
        [getContext(context)]: {
          data: null,
          status: 'ERROR',
        },
      };
    }
    default:
      return state;
  }
};

export { biobankReducer };
